import React from 'react';
import { BookOpen, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export function JournalTile() {
  const navigate = useNavigate();

  return (
    <div className="theme-card p-4 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-purple-500/5 to-blue-500/5 animate-pulse" />
      <div className="relative">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="relative">
              <BookOpen className="w-4 h-4 text-primary" />
              <div className="absolute inset-0 bg-primary/20 blur-xl rounded-full" />
            </div>
            <div>
              <h3 className="text-sm font-medium">Habits Tracker</h3>
              <p className="text-xs text-muted-foreground max-w-[280px]">Track your daily habits and build consistency</p>
            </div>
          </div>
          <button
            onClick={() => navigate('/journal')}
            className="bg-primary hover:bg-primary/90 text-primary-foreground px-3 py-1.5 rounded-lg text-xs font-medium relative group overflow-hidden flex items-center gap-1.5 transition-all duration-300"
          >
            <div className="absolute inset-0 bg-gradient-to-r from-white/0 via-white/10 to-white/0 opacity-0 group-hover:opacity-100 transition-opacity" />
            <span className="relative z-10">
              Track Habits
              <ArrowRight className="w-3 h-3" />
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}